import React from 'react';
import './index.scss';

class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const text = this.props.text || '加载中';
    return (
			<div className="global-loading">
				<span className='loading-icon'></span>
				<span className='loading-text'>{text}</span>
			</div>
    );
  }
}

export default Loading;
